// extracted by mini-css-extract-plugin
export default {"ref-link":"referralLinks_ref-link__fb-4c"};